import { NANO_COEFFICIENT } from './getTraceProcessingTime';

const MS_COEFFICIENT = 1000;

export const getCurrentSpanProcessingTime = span =>
    Date.now() / MS_COEFFICIENT - span.startTime[0] - span.startTime[1] / NANO_COEFFICIENT;
